var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import styled from "styled-components";
var StyledDelimiterSpan = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  margin: 0 0.5rem 0rem 0.5rem;\n"], ["\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  margin: 0 0.5rem 0rem 0.5rem;\n"])));
var Breadcrumbs = function (_a) {
    var children = _a.children, delimiter = _a.delimiter, color = _a.color, size = _a.size;
    return (_jsx("div", { children: React.Children.map(children, function (child, index) {
            return (_jsxs(_Fragment, { children: [React.cloneElement(child, {
                        color: color,
                        size: size,
                    }), _jsx(StyledDelimiterSpan, { children: index < React.Children.count(children) - 1 && (delimiter !== null && delimiter !== void 0 ? delimiter : ">") })] }));
        }) }));
};
export default Breadcrumbs;
var templateObject_1;
